module.exports = __webpack_public_path__ + "static/media/arrow-drop-down.7fbd4936.svg";